import { Component, Input, OnInit } from '@angular/core';
import {PaymentService} from "@modules/private/payment/data/services/view/payment.service";

@Component({
  selector: 'app-payment-form',
  templateUrl: './payment-form.component.html',
  styleUrls: ['./payment-form.component.scss']
})
export class PaymentFormComponent implements OnInit {
  /** Desde la pestaña Exigibilidad el cliente ya está decidido: se fija y se deshabilita (F19). */
  @Input() fixedClient: { _id: string, name: string } | null = null

  constructor(
    public paymentService: PaymentService
  ) {
  }

  ngOnInit(): void {
    if (!this.fixedClient) return
    const client = this.paymentService.entity.get('client')
    client?.setValue(this.fixedClient._id)
    client?.disable()
  }

  get e() {
    return this.paymentService.entity
  }
}
